/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

const AWPackageStatuses = Object.freeze({
  DRAFT: '1',
  PENDING_ACCEPTANCE: '2',
  PENDING_ORDER_CREATION: '3',
  SENT_TO_CONTRACTING: '4',
  ORDER_ISSUED: '5',
  COMPLETE: '6',
  HIDDEN: '7',
  RETURNED: '8',
  RESUBMITTED_TO_CONTRACTING: '9',
  SUBMITTING_TO_CONTRACTING: '10',
  SUBMISSION_ERROR: '11',
  ARCHIVED: '12'
});

export default AWPackageStatuses;
